import React from "react";
import { Link } from "react-router-dom";
import api from "../servicios/api";
import { authHeaders } from "../servicios/auth";

class Listarusuario extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            datosCargadosusuario: false,
            usuarios: [],
            mensaje: ""
        };
    }

    borrarRegistrosusuario = (id) => {

        fetch(api + "usuarios/" + id, {
            method: "DELETE",
            headers: authHeaders()
        })
        .then(respuesta => respuesta.json())
        .then(datos => {

            this.setState({
                mensaje: datos.mensaje || "Empleado eliminado con éxito"
            });

            setTimeout(() => {
                this.setState({ mensaje: "" });
                this.cargarDatosusuario();
            }, 2000);

        })
        .catch(error => {

            

            this.setState({
                mensaje: "Error al eliminar usuario"
            });

        });

    }

    cargarDatosusuario() {

        fetch(api + "usuarios", {
            headers: authHeaders()
        })
        .then(respuesta => respuesta.json())
        .then(datosRespuestausuario => {

            let listaUsuarios = [];

            if (Array.isArray(datosRespuestausuario)) {

                listaUsuarios = datosRespuestausuario.filter(
                    usuario => usuario.idusuario
                );

            }

            this.setState({
                datosCargadosusuario: true,
                usuarios: listaUsuarios
            });

        })
        .catch(error => {

           

            this.setState({
                datosCargadosusuario: true,
                usuarios: [],
                mensaje: "Error al cargar usuarios"
            });

        });

    }

    componentDidMount() {
        this.cargarDatosusuario();
    }

    render() {

        const {
            datosCargadosusuario,
            usuarios,
            mensaje
        } = this.state;

        if (!datosCargadosusuario) {
            return <div>Cargando...</div>;
        }

        return (

            <div className="card">

                <div className="card-header">

                    <Link
                        className="btn btn-success"
                        to="/usuarios/crear"
                    >
                        Agregar nuevo usuario
                    </Link>

                </div>

                <div className="card-body">

                    {mensaje && (
                        <div className="alert alert-success">
                            {mensaje}
                        </div>
                    )}

                    <h4>Lista de usuarios</h4>

                    <div className="table-responsive">

                        <table className="table table-bordered table-hover align-middle">

                            <thead className="table-dark">

                                <tr>
                                    <th>ID</th>
                                    <th>NOMBRE</th>
                                    <th>APELLIDOS</th>
                                    <th>USUARIO</th>
                                    <th>ROL</th>
                                    <th>No. CHAPA</th>
                                    <th>ESTADO</th>
                                    <th>ACCIONES</th>
                                </tr>

                            </thead>

                            <tbody>

                                {usuarios.map((usuario, index) => (

                                    <tr key={usuario.idusuario}>

                                        <td>{index + 1}</td>
                                        <td>{usuario.nombres}</td>
                                        <td>{usuario.apellidos}</td>
                                        <td>{usuario.usuario}</td>
                                        <td>{usuario.rol_nombre}</td>
                                        <td>{usuario.nochapa}</td>
                                        <td>{usuario.estado_nombre}</td>

                                        <td>

                                            <div className="btn-group">

                                                <Link
                                                    className="btn btn-warning btn-sm"
                                                    to={"/usuarios/editarusuario/" + usuario.idusuario}
                                                    title="Editar Usuario"
                                                >
                                                    <i className="bi bi-pencil-square"></i>
                                                </Link>

                                                <button
                                                    type="button"
                                                    className="btn btn-danger btn-sm"
                                                    onClick={() => this.borrarRegistrosusuario(usuario.idusuario)}
                                                    title="Eliminar Usuario"
                                                >
                                                    <i className="bi bi-trash"></i>
                                                </button>

                                                <Link
                                                    className="btn btn-secondary btn-sm"
                                                    to={"/usuarios/contrasena/" + usuario.idusuario}
                                                    title="Cambiar Contraseña"
                                                >
                                                    <i className="bi bi-key"></i>
                                                </Link>

                                            </div>

                                        </td>

                                    </tr>

                                ))}

                            </tbody>

                        </table>

                    </div>

                </div>

                <div className="card-footer text-muted"></div>

            </div>

        );
    }

}

export default Listarusuario;